import thirdPartyApi from 'api/thirdparty'
import { Message } from 'element-ui'
import logClickEvent from '@utils/logClickEvent'
const thirdParty = {
  namespaced: true,
  state: {
    wechatAccount: null,
    wechat_union: null,
    wechat_offical_account: null,
    timer: null,
    qrcode: null,
  },
  getters: {
    wechatAccount: (state) => state.wechatAccount,
    wechat_union: (state) => state.wechat_union,
    wechat_offical_account: (state) => state.wechat_offical_account,
    qrcode: (state) => state.qrcode,
  },
  mutations: {
    setWechatAccount(state, wechatAccount) {
      state.wechatAccount = wechatAccount
    },
    setWechatUnion(state, wechat_union) {
      state.wechat_union = wechat_union
    },
    setWechatOfficalAccount(state, wechat_offical_account) {
      state.wechat_offical_account = wechat_offical_account
    },
    setQrcode(state, qrcode) {
      state.qrcode = qrcode
    },
  },
  actions: {
    async getWechatAccount({ state, commit, dispatch }) {
      const { data } = await thirdPartyApi.getBindStatus()
      if (data?.code == 0) {
        commit('setWechatAccount', data.data)
        if (data.data) {
          commit('setWechatUnion', data.data?.union_id_exists)
          commit('setWechatOfficalAccount', data.data?.oa_open_id_exists)

          if (data.data?.oa_open_id_exists) {
            clearInterval(state.timer)
          }
          dispatch('wxLogin/hide', 'wxLogin', { root: true })
          logClickEvent('微信绑定', '扫码绑定')
        }
      }
    },
    async unbindWx({ commit }, params) {
      const { data } = await thirdPartyApi.unbindWx(params)
      if (data?.code == 0) {
        commit('setWechatAccount', data.data)
        commit('setWechatUnion', null)
        commit('setWechatOfficalAccount', null)
        Message.success(data.message)
      }
    },
    // 轮询getWechatAccount
    async getWechatAccountInterval({ dispatch, state }) {
      dispatch('getWxQrcodeUrl')
      // 5s 轮询一次
      state.timer = setInterval(() => {
        dispatch('getWechatAccount')
      }, 5000)
      // 3min 后清除轮询
      setTimeout(() => {
        dispatch('clearInterval')
        // 提示绑定超时
        Message.warning('绑定超时，请重新绑定')
        dispatch('wxLogin/hide', 'wxLogin', { root: true })
      }, 180000)
    },
    // 清除轮询
    clearInterval({ state }) {
      clearInterval(state.timer)
    },
    // 获取渲染微信二维码的 url
    async getWxQrcodeUrl({ commit }) {
      const { data } = await thirdPartyApi.getWxQrcodeUrl()
      if (data?.code == 0) {
        commit('setQrcode', data.data.bind_qrcode_url)
      }
    },
  },
}

export default thirdParty
